export default __webpack_public_path__ + "static/media/fa.bundle.291aa42b.svg";